export default __webpack_public_path__ + "static/media/saga.6cb9085c.svg";